'use strict';
const angular = require('angular');

export class phoneNumberEditModalComponent {
  /*@ngInject*/
  constructor(Auth, $state, dialogs, $filter, $stateParams, $uibModal, $scope) {
    this.dialogs = dialogs;
    this.$state = $state;
    this.$scope = $scope;

    this.phone = "";
   }

  $onInit() {
    this.config = this.resolve.config;

    if (this.config && this.config.phone) {
     this.phone = angular.copy(this.config.phone);
    }
  }

  ok(model) {
    this.close({$value: this.phone});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.phoneNumberEditModal', [])
  .component('phoneNumberEditModal', {
    template: require('./phone-number-edit-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: phoneNumberEditModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/phone-number-edit-modal/phone-number-edit-modal.component.js